import * as Stimulus from "@hotwired/stimulus"

/**
 * Submits an input's form as soon as the input changes.
 *
 * Reads the input's form property rather than the closest form element, so an
 * input tied to a form elsewhere on the page through its form attribute submits
 * that form. Table rows need this: a row sits inside the bulk selection form and
 * cannot also contain its own.
 */
export class AutoSubmitController extends Stimulus.Controller {
    submit() {
        this.element.form?.requestSubmit();
    }
}
